import { axiosInstance } from '../axios';


class UserSessionService {

  async getState() {
    return await axiosInstance.get(
        '/api/user-session/state',
    );
  }
  async changeCorporation(corporationId) {

      let data = new FormData();
      data.append('corporationId',corporationId);
    return await axiosInstance.post(
        '/api/user-session/change-corporation',
        data,
    );
  }

  async changeCompany(companyId) {
    return await axiosInstance.post(
        '/api/user-session/change-company',
        {},
        {
          params: {
            companyId,
          },
        },
    );
  }

}

export default new UserSessionService();
